import React, {useEffect, useState} from "react";
import {
    Typography,
    Button,
} from "@mui/material";
import {styled} from "@mui/system";
import {ApiDetails} from "../../../../dummyData";
import {showSnackbar} from "../../../../components/SnackBar/SnackBar";
import {DataGrid} from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import Chip from "@mui/material/Chip";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import LoadingButton from "@mui/lab/LoadingButton";
import SendIcon from "@mui/icons-material/Send";
import Dialog from "@mui/material/Dialog";
import {TransitionProps} from "@mui/material/transitions";
import Slide from "@mui/material/Slide";
import {IconSportBillard} from "@tabler/icons-react";

const StyledDataGrid = styled(DataGrid)(() => ({
    "& .MuiDataGrid-columnHeaders": {
        fontSize: "0.9rem",
        fontWeight: 600,
        backgroundColor: "#FBF4F0", // Logo blue
        color: "black", // White text
    },
    "& .MuiDataGrid-row:hover": {
        backgroundColor: "#F4F6F8", // Subtle hover color
    },
    "& .MuiDataGrid-cell:focus": {
        outline: "none",
    },
    "& .MuiDataGrid-cell": {
        fontSize: "0.8rem",
        color: "#002961", // Top bar color
    },
}));

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>,
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const Arrears = (props) => {

    const [arrears, setArrears] = useState({});

    let [arrearInfo, setArrearInfo] = React.useState({
        id: "",
        description: "",
        amount: ""
    });
    const [deleteModal, setOpen] = useState(false);

    const [loading, setLoading] = React.useState(false);


    useEffect(() => {

        fetch(ApiDetails + "pegasus/visionary/tenant/get/tenant/arrears", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"  // Replace with your actual token variable
            },
            body: JSON.stringify({
                tenant_id: props.tenantID,
            }),
        })
            .then(async (response) => {
                let arrears = await response.json();
                if (response.status === 200) {
                    setArrears(arrears);
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Could not fetch transactions.",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                }
            })
            .catch(() => {
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later.",
                    type: "error", // Options: success, error, warning, info
                    position: {vertical: "bottom", horizontal: "right"}, // Options for position
                });

            });
    }, [])


    const arrearsColumn = [
        {
            field: "description",
            headerName: "Description",
            headerAlign: "center",
            // width: 180,
            minWidth: 180,
            flex: 2,
            sortOrder: "asc",
        },
        {
            field: "amount",
            headerName: "Balance",
            headerAlign: "center",
            // width: 120,
            minWidth: 120,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div className="userListUser">
                        {params.row.balance.toLocaleString("en-US", {
                            style: "currency",
                            currency: "KSH",
                        })}
                    </div>
                );
            },
        },
        {
            field: "type",
            headerName: "Type",
            headerAlign: "center",
            align: "center",
            minWidth: 100,
            flex: 1,
            renderCell: (params) => {
                return (
                    <Chip
                        label={params.row.type}
                        color={"warning"}
                        deleteIcon={<IconSportBillard/>}
                        variant="outlined"
                    />
                );

            },
        },
        {
            field: "date_created",
            headerAlign: "center",
            align: "center",
            headerName: "Date",
            // width: 170,
            minWidth: 170,
            flex: 1,
            renderCell: (params) => {
                return (
                    <div
                        style={{
                            fontSize: "12px",
                        }}
                    >
                        {params.row.date_created}
                    </div>
                );
            },
        },
        {
            field: "",
            headerName: "Action",
            headerAlign: "center",
            align: "center",
            minWidth: 100,
            flex: 1,
            renderCell: (params) => {
                if (params.row.type === 'ARREAR') {
                    return (
                        <div className="userListAction">

                            {/*  {
                            params.row.dirty === "TRUE" ? (
                            <>
                                <Tooltip title="Remove Issue" placement="bottom-start">
                                    <BugReport
                                        style={{
                                            color: "red",
                                        }}
                                        onClick={() => {
                                            //open confirm delete modal
                                            //Delete arrear
                                            markArrearDirty(params.row.id, "FALSE");
                                        }}
                                    />
                                </Tooltip>
                            </>
                        ) : (
                            <>
                                <Tooltip title="Raise Issue" placement="bottom-start">
                                    <BugReport
                                        style={{color: "green"}}
                                        onClick={() => {
                                            //open confirm delete modal
                                            //Delete arrear
                                            markArrearDirty(params.row.id, "TRUE");
                                        }}
                                    />
                                </Tooltip>
                            </>
                        )}*/}

                            <Chip
                                label="Delete"
                                color={"error"}
                                onClick={() => {
                                    //open confirm delete modal
                                    //Delete arrear
                                    setArrearInfo({
                                        id: params.row.id,
                                        description: params.row.description,
                                        amount: params.row.amount,
                                    });
                                    setOpen(true);

                                }}
                                deleteIcon={<DeleteIcon/>}
                                variant="outlined"
                            />

                            {/* <Tooltip title="Delete" placement="bottom-start">
                            <DeleteOutline
                                className="userListDelete"
                                style={{
                                    paddingLeft: "10px",
                                    color: "red",
                                }}
                                onClick={() => {
                                    //open confirm delete modal
                                    //Delete arrear
                                    deleteArrears(params.row.id);
                                }}
                            />
                        </Tooltip>*/}
                        </div>
                    );
                } else {
                    return (
                        <></>
                    );
                }
            },
        },
    ];

    const deleteArrears = (id) => {
        setLoading(true)
        //Add arrear to database
        let body = {
            tenant_id: props.tenantID,
            id: id,
        };
        fetch(ApiDetails + "pegasus/visionary/tenant/delete/arrears", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"  // Replace with your actual token variable
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    window.location.reload(false);
                    // handleClose();
                } else {
                    setLoading(false)
                    showSnackbar({
                        title: "Error!",
                        message: "An error occurred processing your request. Please try again later.",
                        type: "error", // success | error | warning | info
                        position: {vertical: "bottom", horizontal: "right"}, // Custom position
                    });

                }
            })
            .catch(() => {
                setLoading(false)
                showSnackbar({
                    title: "Error!",
                    message: "Something Went Wrong. Try Again Later.",
                    type: "error", // success | error | warning | info
                    position: {vertical: "bottom", horizontal: "right"}, // Custom position
                });

            });
    };

    const markArrearDirty = (id, dirty) => {
        //Add arrear to database
        let body = {
            id: id,
            dirty: dirty,
        };

        fetch(ApiDetails + "pegasus/visionary/tenant/arrear/dirty", {
            method: "POST", headers: {
                "Content-Type": "application/json",
                "token": "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d"  // Replace with your actual token variable
            },
            body: JSON.stringify(body),
        })
            .then(async (response) => {
                if (response.status === 200) {
                    showSnackbar({
                        title: "Success!",
                        message: "Arrears successfully marked as dirty.",
                        type: "success", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                } else {
                    showSnackbar({
                        title: "Error!",
                        message: "Failed updating arrear details.",
                        type: "error", // Options: success, error, warning, info
                        position: {vertical: "bottom", horizontal: "right"}, // Options for position
                    });
                }
            })
            .catch(() => {
                showSnackbar({
                    title: "Error!",
                    message: "Something went wrong. Kindly try again later..",
                    type: "error", // Options: success, error, warning, info
                    position: {vertical: "bottom", horizontal: "right"}, // Options for position
                });
            });
    };

    return (
        <>
            <Dialog
                open={deleteModal}
                TransitionComponent={Transition}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle style={{color: "red"}}>
                    Delete {arrearInfo.description}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {/* <Typography>
                            Deleting a Tenant will completely remove them and their respective
                            documents from the system and render a house vacant.
                        </Typography>
                        <br/>*/}
                        <Typography>
                            Are you sure you want to delete this arrear ?
                        </Typography>

                        {/* Adding the id and description elegantly with a faint red background */}
                        <div style={{
                            backgroundColor: "#f8d7da",  // Light red background for a soft effect
                            padding: "15px",
                            marginTop: "20px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",  // subtle shadow for depth
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            maxWidth: "350px",
                            marginLeft: "auto",
                            marginRight: "auto",
                        }}>
                            {/* Title and ID */}
                            <Typography variant="h6" style={{
                                color: "#721c24",
                                fontWeight: "600",
                                marginBottom: "10px"
                            }}>
                                Arrear ID: {arrearInfo.id}
                            </Typography>

                            {/* Amount and Description */}
                            <Typography variant="body1" style={{
                                color: "#721c24",
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginBottom: "10px"
                            }}>
                                Amount:
                                <span style={{
                                    color: "#155724",
                                    fontWeight: "normal",
                                    marginLeft: "5px"
                                }}>
            {arrearInfo.amount.toLocaleString("en-US", {
                style: "currency",
                currency: "KSH",
            })}
        </span>
                            </Typography>

                            <Typography variant="body2" style={{
                                color: "#155724",
                                fontStyle: "italic",
                                fontSize: "14px"
                            }}>
                                Description: {arrearInfo.description}
                            </Typography>
                        </div>

                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen(false)}>
                        <span style={{color: "red"}}>Disagree</span>
                    </Button>
                    <LoadingButton
                        size="small"
                        onClick={() => deleteArrears(arrearInfo.id)}
                        loading={loading}
                        startIcon={<SendIcon/>}
                        style={{color: "green"}}
                        loadingPosition="start"
                    >
                        Agree
                    </LoadingButton>
                </DialogActions>
            </Dialog>

            <StyledDataGrid
                rows={arrears}
                columns={arrearsColumn}
                disableSelectionOnClick
                pageSize={5}
                rowsPerPageOptions={[5, 10]}
                autoHeight
            />
        </>
    )
};

export default Arrears;
